import { Const } from '../lib/const.cls'
import * as types from '@/types'
import * as RxFactory from '../../../../store/api/rx-factory'
import * as Enpoints from '../../../../store/api/endpoints'
import * as COMMON from '../../../../store/commomFunction'
import moment from 'moment'
export const actions = {
    //====================================common-steps==================================
    [Const.RUN_GET_IMAGE_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_IMAGE_OTP, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.otp = result.res_data.otp
                // COMMON._messageDisplayFunction(credentials.localParams.parameter, 'otp resend successfully', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_STEP1]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP1, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_STEP2, { 'transaction_id': result.res_data.transaction_id, 'email': credentials.globalParams.email, 'account_type': credentials.globalParams.account_type, 'residence_country': credentials.globalParams.residence_country })
                localStorage.setItem('step2', JSON.stringify({ 'transaction_id': result.res_data.transaction_id, 'email': credentials.globalParams.email, 'account_type': credentials.globalParams.account_type, "residence_country":  credentials.globalParams.residence_country}))
                credentials.localParams.parameter.$router.replace('/otp-step')

                if (credentials.localParams.page) {
                    credentials.localParams.parameter.countDown = 30
                    credentials.localParams.parameter.resend = false
                    credentials.localParams.parameter.countDownTimer()
                    COMMON._messageDisplayFunction(credentials.localParams.parameter, 'otp resend successfully', 'success')
                }

            } else {
                // commit(Const.SET_STEP2, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_STEP2]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP2, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_STEP3, { 'otp': result.res_data[0].OTP, 'transaction_id': result.res_data[0].transaction_id })
                localStorage.setItem('step3', JSON.stringify({ 'otp': result.res_data[0].OTP, 'transaction_id': result.res_data[0].transaction_id }))
                credentials.localParams.parameter.$router.replace('/password-step')
            } else {
                commit(Const.SET_STEP3, {})
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_STEP3]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP3, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                result.res_data.user.loggedIn = true
                commit(types.SET_STATE, result.res_data.user)
                localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
				if(parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 0){
					credentials.localParams.parameter.$router.replace('/2fa-screen')
				}else{
					credentials.localParams.parameter.$router.replace('/welcome')
				}
                
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'register successfully', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_DEL_DOC]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_DEL_DOC, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                credentials.localParams.parameter.documentJsonData = {}
                credentials.localParams.parameter.stepInfo()
                    // credentials.localParams.parameter.documentJsonData[credentials.localParams.getData] = credentials.localParams.parameter.documentJsonData[credentials.localParams.getData].filter(val => val.id != credentials.globalParams.id)

            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_STEP_INFO]({ commit, state, getters, dispatch }, credentials) {
        let get_user = getters[types.GET_USER]
        const _that = credentials.localParams.parameter
            /*if(parseInt(get_user.step) == 0){
            	_that.$router.replace('individual-step1')
            }else if(parseInt(get_user.step) <=  parseInt(credentials.globalParams.step)){
            	_that.$router.replace('individual-step'+ get_user.step)
            }*/
        COMMON._executeApi(Enpoints.EP_GET_STEP_INFO, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                switch (parseInt(credentials.globalParams.step)) {
                    case 1:
                        if (parseInt(get_user.lead_type) == 0) {
                            // _that.pep = (result.res_data[0].profile.pep != null && result.res_data[0].profile.pep != '') ? result.res_data[0].profile.pep : ''
                            _that.pep = result.res_data[0].profile.pep || '0'
                            _that.us_person = result.res_data[0].profile.us_person || '0'
                            _that.fname = (result.res_data[0].profile.firstname != null && result.res_data[0].profile.firstname != '') ? result.res_data[0].profile.firstname +' '+ result.res_data[0].profile.middlename + ' ' + result.res_data[0].profile.lastname : ''
							 _that.zip_code  = (result.res_data[0].profile.zip_code  != null && result.res_data[0].profile.zip_code  != '') ? result.res_data[0].profile.zip_code  : ''
                            _that.dob = (result.res_data[0].profile.dob != null && result.res_data[0].profile.dob != '' && result.res_data[0].profile.dob != '0000-00-00') ? moment(result.res_data[0].profile.dob).format('YYYY-MM-DD') : ''
                            _that.address1 = (result.res_data[0].profile.address1 != null && result.res_data[0].profile.address1 != '') ? result.res_data[0].profile.address1 : ''
                            _that.nationality = (result.res_data[0].profile.nationality != null && result.res_data[0].profile.nationality != '') ? result.res_data[0].profile.nationality : ''
                            _that.city = (result.res_data[0].profile.city != null && result.res_data[0].profile.city != '') ? result.res_data[0].profile.city : ''
                            _that.residence_country = (result.res_data[0].profile.residence_country != null && result.res_data[0].profile.residence_country != '') ? result.res_data[0].profile.residence_country : ''
                        } else {
                            _that.org_type = (result.res_data[0].profile.org_type != null && result.res_data[0].profile.org_type != '') ? result.res_data[0].profile.org_type : ''
                            _that.legal_name = (result.res_data[0].profile.legal_name != null && result.res_data[0].profile.legal_name != '') ? result.res_data[0].profile.legal_name : ''
                            _that.org_address = (result.res_data[0].profile.org_address != null && result.res_data[0].profile.org_address != '') ? result.res_data[0].profile.org_address : ''
                            _that.registered_country = (result.res_data[0].profile.registered_country != null && result.res_data[0].profile.registered_country != '') ? result.res_data[0].profile.registered_country : ''
                            _that.src_of_funds = (result.res_data[0].profile.src_of_funds != null && result.res_data[0].profile.src_of_funds != '') ? result.res_data[0].profile.src_of_funds : ''
                            _that.tax_id = (result.res_data[0].profile.tax_id != null && result.res_data[0].profile.tax_id != '') ? result.res_data[0].profile.tax_id : ''
                        }
                        break;
                    case 2:
                        if (parseInt(get_user.lead_type) == 0) {
                            _that.terms_agreed = result.res_data[0].profile.terms_agreed
                            if (parseInt(result.res_data[0].profile.terms_agreed) == 1) {
                                _that.check1 = true
                                _that.check2 = true
                                _that.check3 = true
                            }
                        } else {
                            _that.fname = (result.res_data[0].profile.firstname != null && result.res_data[0].profile.firstname != '') ? result.res_data[0].profile.firstname +' '+ result.res_data[0].profile.middlename + ' ' + result.res_data[0].profile.lastname  : ''
                            _that.dob = (result.res_data[0].profile.dob != null && result.res_data[0].profile.dob != '' && result.res_data[0].profile.dob != '0000-00-00') ? moment(result.res_data[0].profile.dob).format('YYYY-MM-DD') : ''
                            _that.address1 = (result.res_data[0].profile.address1 != null && result.res_data[0].profile.address1 != '') ? result.res_data[0].profile.address1 : ''
                            _that.nationality = (result.res_data[0].profile.nationality != null && result.res_data[0].profile.nationality != '') ? result.res_data[0].profile.nationality : ''
                            _that.city = (result.res_data[0].profile.city != null && result.res_data[0].profile.city != '') ? result.res_data[0].profile.city : ''
                            _that.residence_country = (result.res_data[0].profile.residence_country != null && result.res_data[0].profile.residence_country != '') ? result.res_data[0].profile.residence_country : ''
                            _that.org_representative = result.res_data[0].profile.org_representative || '1'
                            _that.job_title = (result.res_data[0].profile.job_title != null && result.res_data[0].profile.job_title != '') ? result.res_data[0].profile.job_title : ''
                        }
                        break;
                    case 3:
                        if(credentials.localParams.from == 'question'){
                            if(result.res_data[0] && result.res_data[0].answers && result.res_data[0].answers.length > 0){
                                result.res_data[0].answers.forEach((v,i)=>{
                                    credentials.localParams.parameter.ans_list[v.ques_id] = v.ans_id.toString()
                                })
                            }
                        }else{
                            if (parseInt(get_user.lead_type) == 0) {
                                // console.log('step-3',result.res_data[0].profile.username)
                                _that.username = result.res_data[0].profile.username
                                if (result.res_data[0].documents.length > 0) {
                                    for (let i = 0; i <= result.res_data[0].documents.length - 1; i++) {
                                        if (_that.documentJsonData[result.res_data[0].documents[i].document_type.split(' ').join('_')] == undefined) {
                                            _that.documentJsonData[result.res_data[0].documents[i].document_type.split(' ').join('_')] = []
                                        }
                                        result.res_data[0].documents[i].name = result.res_data[0].documents[i].document
                                        _that.documentJsonData[result.res_data[0].documents[i].document_type.split(' ').join('_')].push(                                       result.res_data[0].documents[i])
                                    }
                                } else {
                                    // _that.documentJsonSitutaion = { 'identity_document': 'upload', 'residence_document': 'upload', 'ipv_document': 'upload' }
                                }
                            } else {
                                _that.terms_agreed = result.res_data[0].profile.terms_agreed
                                if (parseInt(result.res_data[0].profile.terms_agreed) == 1) {
                                    _that.check1 = true
                                    _that.check2 = true
                                    _that.check3 = true
                                }
                            }
                        }
                        break;
                    case 4:
                        if (parseInt(get_user.lead_type) == 1) {
                            if (result.res_data[0].documents.length > 0) {
                                for (let i = 0; i <= result.res_data[0].documents.length - 1; i++) {
                                    if (_that.documentJsonData[result.res_data[0].documents[i].document_name.split(' ').join('_')] == undefined) {
                                        _that.documentJsonData[result.res_data[0].documents[i].document_name.split(' ').join('_')] = []
                                    }
                                    _that.documentJsonData[result.res_data[0].documents[i].document_name.split(' ').join('_')].push({
                                        id: result.res_data[0].documents[i].id,
                                        name: result.res_data[0].documents[i].document
                                    })
                                }
                            } else {
                                // _that.documentJsonSitutaion = { 'vot_document': 'upload', 'addition_document': 'upload', 'asso_document': 'upload', 'passport_document': 'upload', 'authorize_document': 'upload', 'identityAddress_document': 'upload', 'busiaddress_document': 'upload', 'incorp_document': 'upload' }
                            }
                        }
                        break;
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },

    //====================================individual-steps==================================
    [Const.RUN_STEP4]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP4, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                _localStateStorageUpdateFunc(getters, credentials, commit)
                credentials.localParams.parameter.$router.replace('/individual-step2')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_STEP5]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP5, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                _localStateStorageUpdateFunc(getters, credentials, commit)
                credentials.localParams.parameter.$router.replace('/individual-step3')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_STEP6]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP6, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.step) {
                    _localStateStorageUpdateFunc(getters, credentials, commit)
					
					if (credentials.localParams.page && credentials.localParams.page == 'openFromMobile'){
						credentials.localParams.parameter.continueBrowser = true
					}else{
						credentials.localParams.parameter.$router.replace({ name: "view",query:{id:result.res_data[0].ticketId}})
					}
                } else {
                    credentials.localParams.parameter.documentJsonData = {}
                    credentials.localParams.parameter.stepInfo()
                    credentials.localParams.parameter.clearOld()
                    credentials.localParams.parameter.showTab += 1
                    credentials.localParams.parameter.faliNameChange()
                    if(credentials.localParams.otp_call){
                        credentials.localParams.parameter.ImageOtpSent()
                    }
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GENERATE_OTP]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GENERATE_OTP, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, 'Sent Otp in your registered email id', 'success')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    //====================================corporate-steps===================================
    [Const.RUN_COR_STEP4]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_COR_STEP4, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                _localStateStorageUpdateFunc(getters, credentials, commit)
                credentials.localParams.parameter.$router.replace('/corporate-step2')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_COR_STEP5]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_COR_STEP5, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                _localStateStorageUpdateFunc(getters, credentials, commit)
                credentials.localParams.parameter.$router.replace('/corporate-step3')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_COR_STEP6]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_STEP5, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                _localStateStorageUpdateFunc(getters, credentials, commit)
                credentials.localParams.parameter.$router.replace('/corporate-step4')
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_COR_STEP7]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_COR_STEP7, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                if (credentials.localParams.step) {
                    _localStateStorageUpdateFunc(getters, credentials, commit)
                    credentials.localParams.parameter.$router.replace({ name: "view",query:{id:result.res_data[0].ticketId}}) 
                } else {
                    credentials.localParams.parameter.documentJsonData = {}
                    credentials.localParams.parameter.stepInfo()
                    credentials.localParams.parameter.clearOld()
                    credentials.localParams.parameter.showTab += 1
                }
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_GET_QUESTION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_GET_QUESTION, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                commit(Const.SET_QUESTION, result.res_data)
                // for(let key in result.res_data){
                //     console.log(credentials.localParams.parameter)
                //     if(credentials.localParams.parameter.ans_list[result.res_data[key].question_id] == undefined){
                //         credentials.localParams.parameter.ans_list[result.res_data[key].question_id] = ''
                //     }
                // }
            } else {
                commit(Const.SET_QUESTION,{})
            }
        })
    },
    [Const.RUN_QUESTION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_QUESTION, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let user = getters[types.GET_USER]
                user.step = 4
                commit(types.SET_STATE,user)
                // console.log(credentials.localParams.parameter.ques_step)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_FINANCIAL_QUESTION]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_FINANCIAL_QUESTION, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let user = getters[types.GET_USER]
                user.step = 5
                commit(types.SET_STATE,user)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
    [Const.RUN_FINANCIAL_DOCS]({ commit, state, getters, dispatch }, credentials) {
        COMMON._executeApi(Enpoints.EP_FINANCIAL_DOCS, credentials, { 'Authorization': 'Bearer ' + getters.GET_TOKEN }, commit, (error, result) => {
            if (!error) {
                let user = getters[types.GET_USER]
                user.step = 6
                user.tier = 4
                commit(types.SET_STATE,user)
            } else {
                COMMON._messageDisplayFunction(credentials.localParams.parameter, result.res_data, 'error')
            }
        })
    },
}

function _localStateStorageUpdateFunc(getters, credentials, commit) {
    let user_json = getters[types.GET_USER]
    let user = localStorage.getItem('user')
    user = atob(user);
    user = JSON.parse(user)
    user_json.step = credentials.globalParams.step
    user.step = credentials.globalParams.step

    if ((parseInt(credentials.globalParams.step) == 1 || parseInt(credentials.globalParams.step) == 2) && credentials.globalParams.fname) {
        
		let username = credentials.globalParams.fname
		let username1 = ''
		
		let fname = ''
		let mname = ''
		let lname = ''
		if(username.includes(" ")){
			username1 = username.split(" ")
			
			if(username1.length == 2){
				fname = username1[0]
				mname = ''
				lname = username1[1]
			}
			if(username1.length > 2){
				fname = username1[0]
				mname = username1[1]
				
				for(let i=2 ; i<=username1.length-1 ; i++){
					lname =  lname +' '+ username1[i].toString()
				}
				
			}
		}else{
			fname = username
			mname = ''
			lname = ''
		}
		
		user_json.profile.firstname = fname
		user_json.profile.middlename = mname
		user_json.profile.lastname = lname
		
        user.profile.firstname = fname
		user.profile.middlename = mname
		user.profile.lastname = lname
    }
    if( parseInt(user_json.lead_type) == 0 &&  parseInt(credentials.localParams.step) == 3){
        user_json.step = 3;
        user.step = 3;
        user_json.tier = 2;
        user.tier = 2;
    }
    else if( parseInt(user_json.lead_type) == 1 &&  parseInt(credentials.localParams.step) == 4){
        user_json.step = 4;
        user.step = 4;
        user_json.tier = 2;
        user.tier = 2;
    }
    commit(types.SET_STATE, user_json)
    localStorage.setItem('user', btoa(JSON.stringify(user)))
}

/*
function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        let response_array = []
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (getToken == '') { getToken = '' }
        credentials.localParams.parameter.pageLoader = true

        RxFactory.post(Enpoints.BASE_URL + apiLink, credentials.globalParams, getToken)
            .map(response => response.data)
            .subscribe(data => {
                    credentials.localParams.parameter.pageLoader = false
                    if ('info' in data) {
                        if (data.info === 'OK') {
                            response_array.res_data = data.data
                            callback(false, response_array)
                        } else {
                            if (typeof data.msg == 'object') {
                                response_array.res_data = data.msg.msg
                            } else {
                                response_array.res_data = data.msg
                            }
                            callback(true, response_array)
                        }
                    }
                },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}

function _messageDisplayFunction(getParameter, getMessage, msgType) {
    //getParameter.response_msg = getMessage
    //getParameter.msg_type = msgType
    getParameter.$notify({
        group: 'foo',
        type: msgType,
        text: getMessage,
        duration: 10000,
        closeOnClick: true
    });
}


function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_INFO", msg)
}

function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) {}
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}

function _handleLogout(data, commit, options) {
    const router = options.router
    let user = {}
    localStorage.clear();
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}*/


// WEBPACK FOOTER //
// ./src/plugins/registerSteps/provider/store-addons/actions.js